export const isInStandaloneMode = (): boolean => {
  return window.matchMedia("(display-mode: standalone)").matches || (window.navigator as any).standalone === true;
};
